module.exports = __webpack_public_path__ + "merriweather-regular-webfont.c7a25d2d487694c9682e.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/merriweather-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/merriweather-regular-webfont.woff2
// module chunks = 2